import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import { COMMENT_STATES } from '@app/utils/comments/constants';
import { setAgreementSidebarCommentState } from '@app/reducers/app';

import Select from '@app/components/select';
import { T } from '@app/components/translation';

import style from './comments-state-selector.module.scss';

const { COMMENT_ACTIVE, COMMENT_ALL, COMMENT_RESOLVED } = COMMENT_STATES;

type Props = {
  activeCommentState: string;
};

type ActiveStateType = 'active' | 'resolved';

const selectorStates = [
  {
    label: (
      <T
        _str="Active"
        _comment="Label of an option in a select menu"
      />
    ),
    value: COMMENT_ACTIVE,
  },
  {
    label: (
      <T
        _str="Resolved"
        _comment="Label of an option in a select menu"
      />
    ),
    value: COMMENT_RESOLVED,
  },
  {
    label: (
      <T
        _str="All"
        _comment="Label of an option in a select menu"
      />
    ),
    value: COMMENT_ALL,
  },
];

const CommentsStateSelector = ({ activeCommentState }: Props) => {
  const dispatch = useDispatch();

  const isResolvedStateActive = activeCommentState === COMMENT_RESOLVED;

  const setCurrentlyActiveCommentsState = useCallback(
    (activeState: ActiveStateType) => {
      dispatch(setAgreementSidebarCommentState(activeState));
    },
    [
      dispatch,
    ],
  );

  const stateSelectorClasses = clsx(style.StateSelector, {
    [style.StateSelectorResolved]: isResolvedStateActive,
  });

  const itemsClassName = clsx({
    [style.SelectItemResolved]: isResolvedStateActive,
  });

  const selectorLabel = selectorStates.find(({ value }) => value === activeCommentState)?.label;

  return (
    <Select
      selectClassName={stateSelectorClasses}
      value={activeCommentState}
      itemClassName={style.SelectItem}
      itemsClassName={itemsClassName}
      labelKey="label"
      valueKey="value"
      label={selectorLabel}
      onValueChange={setCurrentlyActiveCommentsState}
      items={selectorStates}
    />
  );
};

export default CommentsStateSelector;
